export default "__VITE_ASSET__cGqh3zSG__"